import type { OfferProductSales } from '../types';

interface ProductWithSales {
  productSales?: OfferProductSales | null;
}

/**
 * FIN-8239: limite de vendas do produto PRINCIPAL da oferta. Prefere o dado
 * atualizado (refetch após cupom) quando ele traz `productSales`; se o refetch
 * veio sem (não pede disponibilidade), cai no dado inicial, que é do mesmo
 * produto. Nunca usa o produto do order bump aceito. Fora da oferta
 * (`isOffer` false), null.
 */
export function resolveOfferProductSales({
  isOffer,
  productData,
  updatedProductData,
}: {
  isOffer: boolean;
  productData?: ProductWithSales | null;
  updatedProductData?: ProductWithSales | null;
}): OfferProductSales | null {
  if (!isOffer) return null;

  return updatedProductData?.productSales ?? productData?.productSales ?? null;
}
